import SportEventDTO from "./SportEventDTO.js"

class LiveDTO {

    constructor(liveData){
        if(!liveData || Object.keys(liveData).length === 0)
            return

        const {_id, provider, date, name, sportEvents} = liveData

        this._id = _id
        this.provider = provider

        this.name = name
        this.date = date

        this.sportEvents = sportEvents?.map(sportEvent => new SportEventDTO(sportEvent))
    }

    getSportsList(){
        const sports = this.sportEvents.map(event => event.phase?.competitionDiscipline?.discipline?.sport?.label)
        return [...new Set(sports)].sort((a, b) => a.localeCompare(b));
    }

}

export default LiveDTO